var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCondashFailicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connection-remove-icon",
    clipPath: "url(#clip0_10176_32570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0208 3.24264L20.6066 1.82843L17.7782 4.65685L16.364 3.24264C15.5829 2.46159 14.3166 2.46159 13.5356 3.24264L10 6.77817L17.0711 13.8492L20.6066 10.3137C21.3877 9.53266 21.3877 8.26633 20.6066 7.48528L19.1924 6.07107L22.0208 3.24264ZM14.9498 4.65685L19.1924 8.89949L17.0711 11.0208L12.8285 6.77817L14.9498 4.65685Z",
    fill: "#D81010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6066 10.172L11.0208 11.5862L9.6066 13.0005L11.0208 14.4147L12.435 13.0005L13.8492 14.4147L12.435 15.8289L13.8492 17.2431L10.3137 20.7786C9.53265 21.5597 8.26632 21.5597 7.48528 20.7786L6.07106 19.3644L3.24264 22.1928L1.82842 20.7786L4.65685 17.9502L3.24264 16.536C2.46159 15.7549 2.46159 14.4886 3.24264 13.7076L6.77817 10.172L8.19238 11.5862L9.6066 10.172ZM8.89949 19.3644L4.65685 15.1218L6.77817 13.0005L11.0208 17.2431L8.89949 19.3644Z",
    fill: "#D81010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10176_32570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondashFailicon);
export default __webpack_public_path__ + "static/media/condash-failicon.f6db9f418cb19ef7703281352436772d.svg";
export { ForwardRef as ReactComponent };